import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "groups" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_UsersDdown = _resolveComponent("UsersDdown")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "modal-to": "#tenants",
    max_width: "48rem",
    centered: false,
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => [
      _createTextVNode(" Assign User to " + _toDisplayString($props.tenant.name), 1 /* TEXT */)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[7] || (_cache[7] = _createElementVNode("label", null, "User", -1 /* HOISTED */)),
        _createVNode(_component_UsersDdown, {
          ref: "uddown",
          modelValue: $data.user_id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.user_id) = $event)),
          "vread-from": "el_item",
          "onUpdate:el_item": $event => (($data.user) = $event),
          "tenant-id": $props.tenant.id,
          class: "users-ddown",
          required: ""
        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:el_item", "tenant-id"]),
        _cache[8] || (_cache[8] = _createElementVNode("label", null, "Groups", -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Checkbox, {
            modelValue: $data.is_superuser,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.is_superuser) = $event)),
            "font-size": "1.4rem"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Superusers")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]),
          _createVNode(_component_Checkbox, {
            modelValue: $data.is_beta,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.is_beta) = $event)),
            "font-size": "1.4rem"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Beta")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]),
          _createVNode(_component_Checkbox, {
            modelValue: $data.is_tenant_manager,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.is_tenant_manager) = $event)),
            "font-size": "1.4rem"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Tenant Manager")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])
        ])
      ])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, { onClick: $options.close }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_Button, {
        primary: "",
        disabled: !$options.can_submit,
        onClick: $options.submit
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [
          _createTextVNode(" Assign ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClickOutside"]))
}